/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1LocationCitiesDropdownQueryResponse,
  GetApiV1LocationCitiesDropdownQueryParams,
  GetApiV1LocationCitiesDropdown401,
  GetApiV1LocationCitiesDropdown500,
} from "../../types/locationCityController/GetApiV1LocationCitiesDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1LocationCitiesDropdown } from "../../clients/locationCityController/getApiV1LocationCitiesDropdown.ts";

export const getApiV1LocationCitiesDropdownQueryKey = (
  params?: GetApiV1LocationCitiesDropdownQueryParams,
) =>
  [
    { url: "/api/v1/location/cities/dropdown" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1LocationCitiesDropdownQueryKey = ReturnType<
  typeof getApiV1LocationCitiesDropdownQueryKey
>;

export function getApiV1LocationCitiesDropdownQueryOptions(
  params?: GetApiV1LocationCitiesDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1LocationCitiesDropdownQueryKey(params);
  return queryOptions<
    GetApiV1LocationCitiesDropdownQueryResponse,
    ResponseErrorConfig<
      GetApiV1LocationCitiesDropdown401 | GetApiV1LocationCitiesDropdown500
    >,
    GetApiV1LocationCitiesDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1LocationCitiesDropdown(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna cidades pertencentes ao estado informado (stateId), ordenadas por nome. **(Requer Authorization para autenticação)**
 * @summary Lista de cidades para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities/dropdown}
 */
export function useGetApiV1LocationCitiesDropdown<
  TData = GetApiV1LocationCitiesDropdownQueryResponse,
  TQueryData = GetApiV1LocationCitiesDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1LocationCitiesDropdownQueryKey,
>(
  params?: GetApiV1LocationCitiesDropdownQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1LocationCitiesDropdownQueryResponse,
        ResponseErrorConfig<
          GetApiV1LocationCitiesDropdown401 | GetApiV1LocationCitiesDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1LocationCitiesDropdownQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1LocationCitiesDropdownQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1LocationCitiesDropdown401 | GetApiV1LocationCitiesDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
